import React from 'react';
import { useParams } from 'react-router-dom';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/**
 * Renders a hand-crafted HTML file (stored server-side at
 * /backend/static_pages/{slug}.html) inside a full-viewport iframe so its
 * own styles, scripts, and layout are preserved 1:1.
 *
 * Route usage:
 *   <Route path="/scott" element={<HostedPage slug="scott" />} />
 *   <Route path="/p/:slug" element={<HostedPage />} />
 */
export const HostedPage = ({ slug: propSlug, title }) => {
  const { slug: paramSlug } = useParams();
  const slug = propSlug || paramSlug;
  const src = `${BACKEND}/api/pages/${slug}`;

  return (
    <iframe
      src={src}
      title={title || slug || 'hosted-page'}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        border: 0,
        margin: 0,
        padding: 0,
      }}
      data-testid={`hosted-page-${slug}`}
    />
  );
};

export default HostedPage;
